import { render } from "./AssignmentResultsComponent.vue?vue&type=template&id=c8eb007c&scoped=true"
import script from "./AssignmentResultsComponent.vue?vue&type=script&lang=js"
export * from "./AssignmentResultsComponent.vue?vue&type=script&lang=js"

import "./AssignmentResultsComponent.vue?vue&type=style&index=0&id=c8eb007c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8eb007c"]])

export default __exports__